module.exports = __webpack_public_path__ + "static/delivery-bfd2fbd8a94bd095fbda5ca1826c5d36.jpg";